import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchBox from "../search/SearchBox";
import { fetchAdminList } from "../../services/adminService";
import { decodeToken } from "../../utils/jwtUtils";

// 페이징1
import Pagination from '../base/Pagination';

const parseJwt = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
};

export default function Admin() {
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState("");
    const [filteredList, setFilteredList] = useState([]);
    const token = localStorage.getItem("token");
    const user = token ? parseJwt(token) : null;
    const isSuperAdmin = user?.auth === 1;
    //페이징2
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 15;

    console.log('디코딩된 사용자 정보:', user);


    useEffect(() => {

        fetchAdminList(token).then(list => setFilteredList(list));
    }, []);

    const handleSearch = () => {
    const trimmedKeyword = keyword.trim().toLowerCase();
    if (trimmedKeyword === "") {
        fetchAdminList(token).then(list => setFilteredList(list));
    } else {
        const filtered = filteredList.filter((admin) =>
            (admin.name && admin.name.toLowerCase().includes(trimmedKeyword)) ||
            (admin.auth_name && admin.auth_name.toLowerCase().includes(trimmedKeyword)) ||
            (admin.username && admin.username.toLowerCase().includes(trimmedKeyword)) ||
            (admin.last_login && admin.last_login.toLowerCase().includes(trimmedKeyword)) ||
            (admin.email && admin.email.toLowerCase().includes(trimmedKeyword)) ||
            (admin.department && admin.department.toLowerCase().includes(trimmedKeyword)) ||
            (admin.mobile_phone && admin.mobile_phone.toLowerCase().includes(trimmedKeyword)) ||
            (admin.phone && admin.phone.toLowerCase().includes(trimmedKeyword))
        );
        setFilteredList(filtered);
    }
};

    const handleReset = () => {
        setKeyword("");
        //fetchAdminList();
        fetchAdminList(token).then(list => setFilteredList(list));
    };

    const handleClick = (admin) => {
        navigate(`/admin/${admin.id}`, { state: { admin: { ...admin, password: admin.password } } });
    };

    // 페이징3
    const indexOfLastLog = currentPage * logsPerPage;
    const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = filteredList.slice(indexOfFirstLog, indexOfLastLog); // filteredList 표 값이랑 맞추기
    const totalPages = Math.ceil(filteredList.length / logsPerPage);

    return (
        <div className="admin">
            <h1>관리자 관리</h1>
            <div className="admin_box">
                <SearchBox
                    keyword={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    onSearch={handleSearch}
                    onReset={handleReset}
                />
                <div className="admin_list">
                    <div className="table">
                        <table>
                            <caption>관리자 관리 표</caption>
                            <colgroup>
                                <col width="13%" />
                                <col width="14%" />
                                <col width="10%" />
                                <col width="10%" />
                                <col width="15%" />
                                <col width="14%" />
                                <col width="14%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>이름</th>
                                    <th>소속</th>
                                    <th>권한</th>
                                    <th>아이디</th>
                                    <th>이메일</th>
                                    <th>휴대폰 번호</th>
                                    <th>내선번호</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(currentLogs) &&
                                    currentLogs.map((admin) => (
                                        <tr key={admin.id} onClick={() => handleClick(admin)} style={{ cursor: "pointer" }}>
                                            <td>{admin.name || "-"}</td>
                                            <td>{admin.department || "-"}</td>
                                            <td>{admin.auth_name || "-"}</td>
                                            <td>{admin.username || "-"}</td>
                                            <td>{admin.email?.trim() ? admin.email : "-"}</td>
                                            <td>{admin.mobile_phone || "-"}</td>
                                            <td>{admin.phone || "-"}</td>
                                        </tr>
                                    ))}
                            </tbody>

                        </table>
                    </div>
                </div>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                />
                <div className="btn-group">
                    {isSuperAdmin && (<button onClick={() => navigate("/admin/department")} className="btncolor04">소속관리</button>)}
                    <button onClick={() => navigate("/admin/new")} className="btncolor01">등록</button>
                </div>
            </div>
        </div>
    );
}
